
import { defineComponent } from 'vue';
import { provideStepper } from './stepper';

export default defineComponent({
  name: 'Wizard',
  props: {
    initialStep: Number,
  },
  setup(props) {
    const stepper = provideStepper();
    if (props.initialStep) {
      // eslint-disable-next-line vue/no-setup-props-destructure
      stepper.currentStep.value = props.initialStep;
    }

    return {
      ...stepper,
    };
  },
});
